import { Component, Input, OnChanges } from '@angular/core'

@Component({
  selector: 'lin-progress-bar',
  template: ` <mat-progress-bar class="progress-bar" [class.shown]="isShown" [mode]="mode"></mat-progress-bar> `,
  styles: ['.progress-bar { opacity: 0; } .shown { opacity: 1; } '],
  standalone: false,
})
export class ProgressBarComponent implements OnChanges {
  mode: 'determinate' | 'indeterminate' = 'indeterminate'
  @Input() isShown: boolean

  ngOnChanges() {
    this.mode = this.isShown ? 'indeterminate' : 'determinate'
  }
}
